import { useContainerBlockContext } from '@lighthouse/block'
import { getWithScopeId } from '@lighthouse/shared'
import { useAtom } from 'jotai'
import { useCallback, useMemo } from 'react'

import { viewIndependentDataAtomFamily } from '@/atoms/dataSource/state'
import { useCurrentStackIdContext } from '@/contexts/PageContext'

interface useViewIndependentPayload {
    blockId: string
    pointer: string
    canSearch: boolean | undefined
}

export const useViewIndependent = (payload: useViewIndependentPayload) => {
    const { blockId, pointer, canSearch } = payload
    const stackId = useCurrentStackIdContext()
    const { scope } = useContainerBlockContext()
    const [viewIndependentData, setViewIndependentData] = useAtom(
        viewIndependentDataAtomFamily({ stackId, dsId: pointer, viewId: getWithScopeId(blockId, scope) })
    )
    const { search, currentPage, rowTotal, recordPoints } = viewIndependentData
    const searchVal = canSearch ? search || '' : ''

    const handleSearch = useCallback(
        (val: string) => {
            setViewIndependentData(draft => {
                draft.search = val
            })
        },
        [setViewIndependentData]
    )

    return useMemo(
        () => ({ searchVal, handleSearch, setViewIndependentData, currentPage, rowTotal, recordPoints }),
        [currentPage, handleSearch, recordPoints, rowTotal, searchVal, setViewIndependentData]
    )
}
